import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { Uploader, UploaderBtn, UploaderDrop, UploaderUnsupport, UploaderList, UploaderFiles, UploaderFile } from './vue-simple-uploader.js';
import SparkMD5 from 'spark-md5';
import { v2Host } from '@/config/host';
import { getToken } from '@/utils/auth';
import FakeUploaderList from './FakeUploaderList';
import { readAsArrayBuffer } from '@/utils/fileReader';
import Worker from '../../file.worker.js';

export default {
  components: {
    Uploader: Uploader,
    UploaderBtn: UploaderBtn,
    UploaderDrop: UploaderDrop,
    UploaderUnsupport: UploaderUnsupport,
    UploaderList: UploaderList,
    UploaderFiles: UploaderFiles,
    UploaderFile: UploaderFile,
    FakeUploaderList: FakeUploaderList
  },

  props: {
    onSuccess: {
      type: Function,
      default: function _default() {}
    },

    onRemove: {
      type: Function,
      default: function _default() {}
    },

    onPreview: {
      type: Function,
      default: function _default() {}
    },

    validate: {
      type: Function,
      default: function _default() {}
    },

    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    accept: {
      type: String,
      default: ''
    },

    options: {
      // 一般不需要传，使用默认的就好
      type: Object,
      default: function _default() {
        return {};
      }
    },

    maxSize: {
      type: Number,
      default: 1.5 * 1024 * 1024 * 1024
    },

    uploadData: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    var _this = this;

    return {
      innerOptions: {
        target: v2Host + '/upload/file',
        chunkSize: 6 * 1024 * 1024, // 分块大小，最小是 5M，S3 的限制
        maxChunkRetries: 3, // 最大自动失败重试上传次数
        testChunks: true, // 是否开启服务器分片校验
        testMethod: 'POST', // 测试的时候使用的 HTTP 方法
        uploadMethod: 'POST', // 真正上传的时候使用的 HTTP 方法
        singleFile: true,
        query: _extends({
          bucket: 'portal' }, this.uploadData),
        headers: {
          'Auth-Token': getToken()
        },
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function checkChunkUploadedByResponse(chunk, response) {
          var res = {};

          var showErrorMessage = function showErrorMessage(msg) {
            _this.$message({
              message: msg || '接口发生错误，请稍后再试或联系开发者',
              type: 'error'
            });
          };

          try {
            res = JSON.parse(response);
          } catch (e) {
            showErrorMessage();
            throw new Error(e.message || 'JSON.parse 发生错误，接口返回数据不是合法的 JSON');
          }

          console.log('checkChunkUploadedByResponse: ', res);

          var code = Number(res.code);

          if (code !== 0) {
            showErrorMessage(res.msg);
            // 这里抛出错误是为了让 vue-simple-uploader 认为这里发生了错误
            // 直接返回 false 或不返回，组件会继续执行代码（如只有一个分块的时候，会认为这个已经上传成功了，触发成功回调函数更新UI为成功状态），导致 UI 上展示不正确
            throw new Error(res.message || '抛出一个错误');
          }

          // 上传完成
          if (code === 0 && _.get(res, 'data.file.is_completed')) {
            return true;
          }

          // res.upload_chunks = [2, 3, 4, 5, 6, 8, 10, 11, 12, 13, 17, 20, 21]
          // 检查分块是否已经上传过了
          var uploadChunks = _.get(res, 'data.file.upload_chunks') || [];
          console.log('检查分块是否已经上传过了: ', uploadChunks.indexOf(chunk.offset + 1) >= 0);
          return uploadChunks.indexOf(chunk.offset + 1) >= 0;
        },
        processParams: function processParams(params) {
          // 将属性名改成 snakeCase，兼容后端接口的数据规范
          return _.mapKeys(params, function (value, key) {
            return _.snakeCase(key);
          });
        }
      },
      autoStart: false, // 是否自动开始上传
      statusText: {
        success: '上传成功',
        error: '上传出错',
        uploading: '上传中',
        paused: '未上传',
        waiting: '等待中'
      },

      // 其它
      md5: '',
      uploader: null,
      fileInfo: null, // 接口返回信息
      isCompleted: false,
      isReady: false,

      innerFileList: this.fileList
    };
  },


  computed: {
    attrs: function attrs() {
      return {
        accept: this.accept
      };
    }
  },

  watch: {
    fileList: function fileList(val) {
      this.innerFileList = val;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.uploader = _this2.$refs.uploader.uploader;
    });
    this.innerOptions = _extends({}, this.innerOptions, this.options);

    // 支持 web worker 的话，使用 web worker 去算 md5
    if (this.isSupportWorker()) {
      this.worker = new Worker();
      this.worker.addEventListener('message', this.handleWorkerMessage);
    }
  },
  destroyed: function destroyed() {
    // 清理内存
    this.file && this.removeFile(this.file);
    this.worker && this.worker.terminate();
  },


  methods: {
    handleWorkerMessage: function handleWorkerMessage(event) {
      if (event.data.error) {
        this.$message.error(event.data.error.message || 'Web Worker 处理文件发生错误，请稍后再试或联系开发者');
        return;
      }

      if (event.data.type === 'calculate-md5' && event.data.md5) {
        this.updateStateAfterComputedMD5(event.data.md5);
      }
    },
    handleFillAdded: function handleFillAdded(file) {
      this.isCompleted = false;
      this.isReady = false;
      this.innerFileList = [];
      // 上传之前 paused 状态的文案
      this.statusText.paused = '未上传';
      this.file = file; // 当前选择的文件

      if (this.validate(file) === true && this.validateFileSize(file) === true) {
        if (this.isSupportWorker()) {
          this.worker.postMessage({ type: 'calculate-md5', file: file.file }); // 派发事件给 web woker
        } else {
          this.computeMD5(file.file);
        }
      } else {
        this.removeFile(file);
      }
    },
    handleChange: function handleChange(file) {},
    handleFileProgress: function handleFileProgress(rootFile, file, chunk) {
      console.log('\u4E0A\u4F20\u4E2D ' + file.name + '\uFF0Cchunk\uFF1A' + chunk.startByte / 1024 / 1024 + ' ~ ' + chunk.endByte / 1024 / 1024);
    },


    // 一个文件上传成功事件，第一个参数 rootFile 就是成功上传的文件所属的根 Uploader.File 对象，它应该包含或者等于成功上传文件；第二个参数 file 就是当前成功的
    // eslint-disable-next-line
    handleFileSuccess: function handleFileSuccess(rootFile, file, response, chunk) {
      var _this3 = this;

      var res = {};

      try {
        res = JSON.parse(response);
      } catch (error) {
        res = {};
      }

      var code = Number(res.code);
      var uploadComplete = function uploadComplete() {
        _this3.$message({ message: file.name + ' 上传成功', type: 'info' });
        // 上传完成后更新文件内容
        _this3.fileInfo = _.get(res, 'data.file');
        _this3.isCompleted = true;
        // 加工回调函数的值，兼容原有代码
        _.isFunction(_this3.onSuccess) && _this3.onSuccess(_Object$assign({}, res, {
          data: _extends({
            // object_key 格式 portal://upload/2019/5/13/a5f114da37a87b13791c6a1be8698217.mp4
            file_path: _this3.fileInfo.object_key,
            origin_name: _this3.fileInfo.filename
          }, _this3.fileInfo)
        }));
      };
      var uploadUnCompleted = function uploadUnCompleted() {
        _this3.isCompleted = false;
        _this3.$message({ message: res.message, type: 'error' });
      };

      console.log('handleFileSuccess: ', rootFile, file, res, chunk);
      if (code === 0 && _.get(res, 'data.file.is_completed')) {
        uploadComplete();
      } else {
        uploadUnCompleted();
      }
    },
    handleUploadStart: function handleUploadStart() {
      console.log('upload start');
      // 上传开始之后暂停状态的文案修改
      this.statusText.paused = '已暂停';
    },
    handleUploadComplete: function handleUploadComplete() {
      console.log('upload complete');
    },
    handleFileRetry: function handleFileRetry(rootFile, file, chunk) {
      console.log('file retry');
    },
    handleFileRemoved: function handleFileRemoved(file) {
      _.isFunction(this.onRemove) && this.onRemove();
      console.log('file removed');
    },
    handleFakeFileRemoved: function handleFakeFileRemoved(file) {
      this.innerFileList = [];
      _.isFunction(this.onRemove) && this.onRemove();
    },
    handleFilePreview: function handleFilePreview(_ref) {
      var event = _ref.event,
          file = _ref.file;

      console.log('文件上传状态：', file.isComplete());

      var isNeedToPreview = function isNeedToPreview() {
        return file.isComplete() && !event.target.parentNode.classList.contains('uploader-file-actions');
      };

      if (isNeedToPreview()) {
        _.isFunction(this.onPreview) && this.onPreview(this.fileInfo);
      }
    },
    handleFakeFilePreview: function handleFakeFilePreview(_ref2) {
      var event = _ref2.event,
          file = _ref2.file;

      if (!event.target.parentNode.classList.contains('uploader-file-actions')) {
        _.isFunction(this.onPreview) && this.onPreview(file);
      }
    },
    validateFileSize: function validateFileSize(file) {
      var _this4 = this;

      var size = '';

      if (file.size > this.maxSize) {
        this.$message.error('\u6587\u4EF6\u5927\u5C0F\u8D85\u8FC7\u9650\u5236\uFF0C\u6700\u5927\u4E0D\u80FD\u8D85\u8FC7' + size);
        return false;
      }

      var isGreaterThan1G = function isGreaterThan1G() {
        return _this4.maxSize > 1024 * 1024 * 1024;
      };

      if (isGreaterThan1G()) {
        size = this.maxSize / 1024 / 1024 / 1024;
        size = size + 'G';
      } else {
        size = this.maxSize / 1024 / 1024;
        size = size + 'M';
      }

      return true;
    },
    isSupportWorker: function isSupportWorker() {
      return window.Worker && _.isFunction(window.Worker);
    },


    /**
     * @param {string} md5
     */
    updateStateAfterComputedMD5: function updateStateAfterComputedMD5(md5) {
      this.md5 = md5;
      this.file.uniqueIdentifier = md5;
      this.isReady = true; // 在计算好 md5 之前才允许上传

      // 小于 50M 的文件直接上传
      if (this.file.size < 50 * 1024 * 1024) {
        this.file.resume(); // 开始上传
      }
    },
    computeMD5: function computeMD5(file) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var time, buffer, md5;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                time = new Date().getTime();
                _context.prev = 1;
                _context.next = 4;
                return readAsArrayBuffer(file);

              case 4:
                buffer = _context.sent;
                md5 = SparkMD5.ArrayBuffer.hash(buffer);


                _this5.updateStateAfterComputedMD5(md5);
                console.log('MD5\u8BA1\u7B97\u5B8C\u6BD5\uFF1A' + file.name + ' MD5\uFF1A' + md5 + ' \u7528\u65F6\uFF1A' + (new Date().getTime() - time) + ' ms');
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);
                _this5.removeFile(file);
                _this5.$message.error(_context.t0.message || '文件处理失败');

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[1, 10]]);
      }))();
    },
    removeFile: function removeFile(file) {
      this.uploader.removeFile(file || this.file);
      this.file = null;
    }
  }
};